<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.7617 10.4538L7.16166 15.0538L6.10791 14L11.7617 8.34625L17.4154 14L16.3617 15.0538L11.7617 10.4538Z" fill="currentColor"/>
</svg>
